export const sortCollator = new Intl.Collator("en-US");
